export { default } from './Divider';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Divider/index.js
// module id = 822
// module chunks = 2